const capitalize = (str) => str.charAt(0).toUpperCase() + str.substring(1);
var capitalize_default = capitalize;
export {
  capitalize_default as default
};
